import { HttpClient } from '../HttpClient';
/**
 * * Get Feature Flag
 */

export const GetFeatureFlag = async (featureflagId) => {
  try {
    const { data } = await HttpClient.get(`api/featureflags/${featureflagId}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
